<!--
  ~ Copyright (C) 2026 - Potentially Ltd
  ~
  ~ Please see distribution for license.
-->

<div class="v3-image-cropper">
  <div class="v3-image-cropper__toolbar">
    <div class="v3-image-cropper__tools">
      <ptl-button
        [type]="'tertiary-neutral'"
        [size]="'sm'"
        [icon]="LucideRotateCcw"
        [ariaLabel]="'translations.global.imageCrop.rotateLeft' | transloco"
        (clicked)="rotateLeft()"
      ></ptl-button>
      <ptl-button
        [type]="'tertiary-neutral'"
        [size]="'sm'"
        [icon]="LucideRotateCw"
        [ariaLabel]="'translations.global.imageCrop.rotateRight' | transloco"
        (clicked)="rotateRight()"
      ></ptl-button>
      <ptl-button
        [type]="'tertiary-neutral'"
        [size]="'sm'"
        [icon]="LucidePlus"
        [ariaLabel]="'translations.global.imageCrop.zoomIn' | transloco"
        (clicked)="zoomIn()"
      ></ptl-button>
      <ptl-button
        [type]="'tertiary-neutral'"
        [size]="'sm'"
        [icon]="LucideMinus"
        [ariaLabel]="'translations.global.imageCrop.zoomOut' | transloco"
        (clicked)="zoomOut()"
      ></ptl-button>
      <ptl-button
        [type]="'tertiary-neutral'"
        [size]="'sm'"
        [icon]="LucideFlipHorizontal"
        [ariaLabel]="'translations.global.imageCrop.flipHorizontal' | transloco"
        (clicked)="flipHorizontal()"
      ></ptl-button>
      <ptl-button
        [type]="'tertiary-neutral'"
        [size]="'sm'"
        [icon]="LucideFlipVertical"
        [ariaLabel]="'translations.global.imageCrop.flipVertical' | transloco"
        (clicked)="flipVertical()"
      ></ptl-button>

      @if (!aspectLocked) {
        <span class="v3-image-cropper__divider"></span>
        <div class="v3-image-cropper__aspects">
          @for (preset of aspectPresets; track preset.id) {
            <ptl-toggle-chip
              [label]="preset.label"
              [size]="'s'"
              [active]="activeAspectId === preset.id"
              (clicked)="selectAspect(preset)"
            ></ptl-toggle-chip>
          }
        </div>
      }
    </div>

    <div class="v3-image-cropper__toolbar-end">
      <ptl-button
        [type]="'link-neutral'"
        [size]="'sm'"
        [text]="'translations.global.imageCrop.reset' | transloco"
        (clicked)="resetEdits()"
      ></ptl-button>
      @if (showClose()) {
        <button
          type="button"
          class="v3-image-cropper__close"
          (click)="cancelCrop()"
          [attr.aria-label]="'translations.global.ariaLabels.closeDialog' | transloco"
        >
          <ptl-icon [icon]="LucideX" [size]="'m'"></ptl-icon>
        </button>
      }
    </div>
  </div>

  <div class="v3-image-cropper__canvas">
    @if (description) {
      <p class="v3-image-cropper__description fs-body-s">{{ description }}</p>
    }

    @if (isAnimatedGif) {
      <div class="v3-image-cropper__gif">
        <img [src]="imageBase64" [alt]="'translations.global.imageCrop.animatedGifAlt' | transloco" />
      </div>
    } @else {
      <image-cropper
        #cropper
        [imageFile]="imageFile"
        [imageBase64]="imageBase64"
        [transform]="transform"
        [containWithinAspectRatio]="containWithinAspectRatio"
        [maintainAspectRatio]="maintainAspectRatio"
        [aspectRatio]="aspectRatio"
        [roundCropper]="roundCropper"
        [resizeToWidth]="resizeToWidth"
        [resizeToHeight]="resizeToHeight"
        [onlyScaleDown]="onlyScaleDown"
        [backgroundColor]="backgroundColor"
        [format]="imageFormat"
        (imageCropped)="updateCroppedImage($event)"
      ></image-cropper>
    }
  </div>

  <div class="v3-image-cropper__footer">
    <div class="v3-image-cropper__actions">
      <ptl-button [type]="'secondary-neutral'" [size]="'sm'" [text]="cancelText" (clicked)="cancelCrop()"></ptl-button>
      <ptl-button
        data-testid="image-crop-apply"
        [type]="'primary'"
        [size]="'sm'"
        [text]="'translations.global.imageCrop.applyCrop' | transloco"
        (clicked)="saveCrop()"
      ></ptl-button>
    </div>
  </div>
</div>
